if (!customElements.get('phone-model-picker')) {
  const defaultModels = ["iPhone 17 Pro Max","iPhone 17 Pro","iPhone 17 Air","iPhone 17","iPhone 16 Pro Max","iPhone 16 Plus","iPhone 16 Pro","iPhone 16","iPhone 16e","iPhone 15 Pro Max","iPhone 15 Plus","iPhone 15 Pro","iPhone 15","iPhone 14 Pro Max","iPhone 14 Plus","iPhone 14 Pro","iPhone 14","iPhone 13 Pro Max","iPhone 13 Pro","iPhone 13 Mini","iPhone 13","iPhone 12 Pro Max","iPhone 12 Pro","iPhone 12 Mini","iPhone 12","iPhone 11 Pro Max","iPhone 11 Pro","iPhone 11","iPhone 8 Plus","iPhone 8","iPhone 7 Plus","iPhone 7","iPhone 7G","iPhone 6 Plus","iPhone 6S Plus","iPhone 6","iPhone 6S","iPhone SE","iPhone X","iPhone XR","iPhone XS","iPhone XS Max","Samsung Galaxy S26 Ultra","Samsung Galaxy S25 Ultra","Samsung Galaxy S25 Plus","Samsung Galaxy S25+","Samsung Galaxy S25 FE","Samsung Galaxy S25 FE 5G","Samsung Galaxy S25","Samsung Galaxy S24 Ultra","Samsung Galaxy S24+","Samsung Galaxy S24","Samsung Galaxy S23 Ultra","Samsung Galaxy S23+","Samsung Galaxy S23","Samsung Galaxy S22 Ultra","Samsung Galaxy S22 Plus","Samsung Galaxy S22+","Samsung Galaxy S22","Samsung Galaxy S21 Ultra","Samsung Galaxy S21 Plus","Samsung Galaxy S21+","Samsung Galaxy S21 FE 5G","Samsung Galaxy S21","Samsung Galaxy S20 Ultra","Samsung Galaxy S20 Plus","Samsung Galaxy S20+","Samsung Galaxy S20 FE 5G","Samsung Galaxy S20","Samsung Galaxy S9 Plus","Samsung Galaxy S9","Samsung Galaxy S8 Plus","Samsung Galaxy S8","Samsung Galaxy Note 20 ultra","Samsung Galaxy Note 20","Samsung Galaxy Note 10 Plus","Samsung Galaxy Note 10+","Samsung Galaxy Note 10 Lite","Samsung Galaxy Note 10","Samsung Galaxy Note 9","Samsung Galaxy Note 8","Samsung Galaxy A73","Samsung Galaxy A73 5G","Samsung Galaxy A72","Samsung Galaxy A71","Samsung Galaxy A70","Samsung Galaxy A55 5G","Samsung Galaxy A54","Samsung Galaxy A54 5G","Samsung Galaxy A54 4G","Samsung Galaxy A53","Samsung Galaxy A53 5G","Samsung Galaxy A53 4G","Samsung Galaxy A52","Samsung Galaxy A52 4G","Samsung Galaxy A52s","Samsung Galaxy A51","Samsung Galaxy A51 4G","Samsung Galaxy A50","Samsung Galaxy A50s","Samsung Galaxy A35 5G","Samsung Galaxy A34 5G","Samsung Galaxy A34 4G","Samsung Galaxy A33 5G","Samsung Galaxy A32 5G","Samsung Galaxy A32 4G","Samsung Galaxy A31","Samsung Galaxy A30","Samsung Galaxy A30s","Samsung Galaxy A27","Samsung Galaxy A25","Samsung Galaxy A24","Samsung Galaxy A23","Samsung Galaxy A23 4G","Samsung Galaxy A22 5G","Samsung Galaxy A22 4G","Samsung Galaxy A21s","Samsung Galaxy A20","Samsung Galaxy A20s","Samsung Galaxy A15 5G","Samsung Galaxy A15 4G","Samsung Galaxy A14 5G","Samsung Galaxy A14 4G","Samsung Galaxy A13 5G","Samsung Galaxy A13 4G","Samsung Galaxy A12","Samsung Galaxy A11","Samsung Galaxy A10","Samsung Galaxy A10s","Samsung Galaxy A07","Samsung Galaxy A06","Samsung Galaxy A06 4G","Samsung Galaxy A05","Samsung Galaxy A05s","Samsung Galaxy A04e","Samsung Galaxy A04","Samsung Galaxy A04 4G","Samsung Galaxy A04s","Samsung Galaxy A03","Samsung Galaxy A03 4G","Samsung Galaxy A03 (164)","Samsung Galaxy A03s","Samsung Galaxy M55","Samsung Galaxy M54","Samsung Galaxy M53","Samsung Galaxy M52","Samsung Galaxy M52 5G","Samsung Galaxy M51","Samsung Galaxy M33","Samsung Galaxy M32","Samsung Galaxy M31","Samsung Galaxy M23","Samsung Galaxy M22","Samsung Galaxy M21","Xiaomi Mi 11 Lite","Xiaomi Mi Note 10 Lite","Xiaomi Mi 10T","Xiaomi Mi 9T","Xiaomi Mi A2","Xiaomi Redmi Note 14 4G","Xiaomi Redmi Note 13 Pro+","Xiaomi Redmi Note 13 Pro","Xiaomi Redmi Note 13","Xiaomi Redmi Note 13 5G","Xiaomi Redmi Note 13 4G","Xiaomi Redmi Note 12 Pro+","Xiaomi Redmi Note 12 Pro","Xiaomi Redmi Note 12T Pro","Xiaomi Redmi Note 12","Xiaomi Redmi Note 12 5G","Xiaomi Redmi Note 12 4G","Xiaomi Redmi Note 12S","Xiaomi Redmi Note 11 Pro+","Xiaomi Redmi Note 11 Pro","Xiaomi Redmi Note 11 Pro 4G","Xiaomi Redmi Note 11T Pro","Xiaomi Redmi Note 11","Xiaomi Redmi Note 11S","Xiaomi Redmi Note 11T","Xiaomi Redmi Note 10 Pro Max","Xiaomi Redmi Note 10 Pro","Xiaomi Redmi Note 10 Pro 4G","Xiaomi Redmi Note 10","Xiaomi Redmi Note 10 5G","Xiaomi Redmi Note 10S","Xiaomi Redmi Note 9 Pro Max","Xiaomi Redmi Note 9 Pro","Xiaomi Redmi Note 9","Xiaomi Redmi Note 9S","Xiaomi Redmi Note 9T","Xiaomi Redmi Note 8 Pro","Xiaomi Redmi Note 8","Xiaomi Redmi 15c","Xiaomi Redmi 13","Xiaomi Redmi 13 4G 2024","Xiaomi Redmi 13C","Xiaomi Redmi 12","Xiaomi Redmi 12 4G 2023","Xiaomi Redmi 12C","Xiaomi Redmi 11","Xiaomi Redmi 11 Prime","Xiaomi Redmi 10","Xiaomi Redmi 10 4G 2021","Xiaomi Redmi 10 Prime","Xiaomi Redmi 10A","Xiaomi Redmi 10C","Xiaomi Redmi 9","Xiaomi Redmi 9 Power","Xiaomi Redmi 9A","Xiaomi Redmi 9C","Xiaomi Redmi 9T","Xiaomi Redmi 8","Xiaomi Redmi 8A","Xiaomi Redmi A7 Pro","Xiaomi Redmi A3","Xiaomi Redmi A3x","Xiaomi POCO C65","Xiaomi POCO C55","Xiaomi POCO C50","Xiaomi POCO C40","Xiaomi POCO C31","Xiaomi Poco X8 Pro","Xiaomi POCO X6 Pro","Xiaomi POCO X6","Xiaomi POCO X5 Pro","Xiaomi POCO X5","Xiaomi POCO X4 GT","Xiaomi POCO X3 Pro","Xiaomi POCO X3","Xiaomi POCO X3 NFC","Xiaomi POCO X2","Xiaomi 11 Lite 5G","Oppo Find X9 Pro","Oppo Find X9","Oppo Reno 15 Pro Max","Oppo Reno 15 Pro 5G","Oppo Reno 15","Oppo Reno 15 5G","Oppo Reno 14 Pro","Oppo Reno 14 Pro 5G","Oppo Reno 14","Oppo Reno 14 5G","Oppo Reno 14F","Oppo Reno 13F","Oppo Reno 12 Pro","Oppo Reno 12","Oppo Reno 12 F","Oppo Reno 12F 4G","Oppo Reno 11 Pro","Oppo Reno 11","Oppo Reno 11 F","Oppo Reno 10 Pro","Oppo Reno 10","Oppo Reno 10 5G","Oppo Reno 9 Pro","Oppo Reno 9","Oppo Reno 8 Pro Plus 5G","Oppo Reno 8","Oppo Reno 8 5G","Oppo Reno 8T","Oppo Reno 8T 5G","Oppo Reno 8T 4G","Oppo Reno 7","Oppo Reno 7 5G","Oppo Reno 7 4G","Oppo Reno 7Z","Oppo Reno 6 Pro","Oppo Reno 6","Oppo Reno 6 5G","Oppo Reno 6 4G","Oppo Reno 5 Pro","Oppo Reno 5","Oppo Reno 4 Pro","Oppo Reno 4","Oppo Reno 3 Pro","Oppo Reno 3","Oppo Reno 3 4G","Oppo Reno 2","Oppo F21 Pro","Oppo F19 Pro","Oppo F19","Oppo F17","Oppo F15","Oppo F11 Pro","Oppo F11","Oppo F9","Oppo F7","Oppo F5","Oppo A95","Oppo A94 4G","Oppo A79","Oppo A78","Oppo A78 4G","Oppo A77","Oppo A76","Oppo A74","Oppo A59","Oppo A58","Oppo A58 4G 2023","Oppo A57","Oppo A55","Oppo A54","Oppo A53","Oppo A33","Oppo A31","Oppo A17","Oppo A17k","Oppo A16","Oppo A16k","Oppo A15","Oppo A15s","Oppo A12","Oppo A7","Oppo A6 Pro 4G","Oppo A6","Oppo A5 Pro","Oppo A5 2025","Oppo A5 2020","Oppo A5s","Oppo A3X","Realme GT Neo 6 SE","Realme GT 6","Realme GT 6T","Realme GT5 Pro","Realme GT Neo 5","Realme GT Neo 5 SE","Realme GT5","Realme GT Neo 3","Realme GT Neo 3T","Realme Narzo 70 Pro","Realme Narzo 70x","Realme Narzo N63","Realme Narzo 60 Pro","Realme Narzo 60 5G","Realme Narzo 60x","Realme Narzo N55","Realme Narzo N53","Realme Narzo 50 Pro 5G","Realme Narzo 50A Prime","Realme Narzo 50i Prime","Realme Narzo 50","Realme Narzo 50 5G","Realme Narzo 50A","Realme Narzo 50i","Realme Note 70","Realme C75 4G","Realme C71","Realme C67 4G","Realme C65","Realme C63","Realme C55","Realme C53","Realme C51","Realme C25","Realme 15","Realme 15T","Realme 14 Pro+","Realme 14 Pro","Realme 14","Realme 14T","Realme 13 Pro+","Realme 13 Pro","Realme 13","Realme 12 Pro+","Realme 12+","Realme 12 Pro","Realme 12","Realme 12x","Realme 11 Pro+","Realme 11 Pro","Realme 11","Realme 11 5G","Realme 11x","Realme 10 Pro+","Realme 10 Pro","Realme 10","Realme 10 5G","Realme 10T","Realme 9 Pro+","Realme 9 Pro","Realme 9","Realme 9 5G","Realme 9i","Realme 9i 5G","Realme 8 Pro","Realme 8","Realme 8 5G","Realme 8i","Realme 8s","Realme 7 Pro","Realme 7","Realme 7 5G","Realme 7i","Realme 6 Pro","Realme 6","Realme 6i","Realme 6s","Realme 5 Pro","Realme 5","Realme 3 Pro","Honor Magic 8 Pro","Honor Magic 7 Pro","Honor Magic 6 Pro","Honor X9B","Honor X9C","Honor X8 4G","Honor X6A","Honor X6C","Honor X6D","Honor P30 Pro","Honor P30 Lite","Honor P20 Pro","Honor P20 Lite","Honor Y7 2019","Honor 400","Honor 200 Pro","Honor 200 Lite","Honor 200 Lite 5G","Honor 200","Honor 200 5G","Honor 100 Pro","Honor 100","Honor 90 Pro","Honor 90 Lite","Honor 90","Honor 90 GT","Honor 50","Infinix GT 50 Pro","Infinix GT 30 Pro","Infinix GT 20 Pro","Infinix Note 60 Pro","Infinix Note 50 Pro+ 5G","Infinix Note 50s 5G+","Infinix Note 50 Pro (4G)","Infinix Note 50 (4G)","Infinix Note 50S","Infinix Note 50s 5G","Infinix Note 50x 5G","Infinix Note 40 Pro+ 5G","Infinix Note 40 Pro 5G","Infinix Note 40 5G","Infinix Note 40 (4G)","Infinix Note 40X 5G","Infinix Note 30 Pro","Infinix Note 30 5G","Infinix Note 30i","Infinix Note 12 Pro","Infinix Note 12 Pro 5G","Infinix Note 12","Infinix Note 12 5G","Infinix Note Edge","Infinix Hot 60 Pro Plus","Infinix Hot 60 5G+","Infinix Hot 60 Pro","Infinix Hot 60","Infinix Hot 60i","Infinix Hot 60i 4G","Infinix Hot 50 Pro+","Infinix Hot 50 (5G)","Infinix Hot 50i","Infinix Hot 40 Pro","Infinix Hot 40 (4G / HD)","Infinix Hot 40i","Infinix Hot 30","Infinix Hot 30 5G","Infinix Hot 30 Play","Infinix Hot 30i","Infinix Hot 30i NFC","Infinix Hot 20","Infinix Hot 20 5G","Infinix Hot 20 Play","Infinix Hot 20i","Infinix Hot 20s","Infinix Smart 20","Infinix Smart 10","Infinix Smart 9","Infinix Smart 8 4G","Vivo X300 Pro","Vivo V70 FE","Vivo V60 5G","Vivo V36 4G","Vivo V30 Pro","Vivo V30 Lite","Vivo V30e","Vivo V30","Vivo V29 Pro","Vivo V29e","Vivo V29","Vivo V27 Pro","Vivo V27e","Vivo V27","Vivo V25 Pro","Vivo V25e","Vivo V25","Vivo V23 Pro","Vivo V23e","Vivo V23","Vivo V21e","Vivo V21","Vivo V20 SE","Vivo V20","Vivo V19","Vivo V17 Pro","Vivo V17","Vivo V15 Pro","Vivo V15","Vivo S18 Pro","Vivo S18e","Vivo S18","Vivo S17e","Vivo S17","Vivo S16e","Vivo S16","Vivo S15e","Vivo S15","Vivo Y300","Vivo Y200e","Vivo Y200","Vivo Y200i","Vivo Y100","Vivo Y100 5G","Vivo Y100i","Vivo Y56","Vivo Y55","Vivo Y36","Vivo Y35","Vivo Y31D","Vivo Y27","Vivo Y27s","Vivo Y22","Vivo Y22s","Vivo Y21","Vivo Y21D","Vivo Y21s","Vivo Y20","Vivo Y20G","Vivo Y20s","Vivo Y17","Vivo Y16","Vivo Y15","Vivo Y15s","Vivo Y12","Vivo Y12s","Vivo Y11","Vivo Y05e","Vivo Y05 4G 2026","OnePlus Nord 2","OnePlus 11","OnePlus 10R","OnePlus 9 Pro","OnePlus 8 Pro","OnePlus 7 Pro","OnePlus 7T","OnePlus 6T"];

  const modelAdditions = new Map([
    ['Samsung Galaxy A55 5G', ['Samsung Galaxy A57 5G', 'Samsung Galaxy A56 5G']],
    ['Samsung Galaxy A35 5G', ['Samsung Galaxy A37 5G', 'Samsung Galaxy A36 5G']],
    ['Samsung Galaxy A25', ['Samsung Galaxy A26 5G']],
    ['Samsung Galaxy A15 5G', ['Samsung Galaxy A17 5G', 'Samsung Galaxy A17 4G', 'Samsung Galaxy A16 5G', 'Samsung Galaxy A16 4G']],
    ['Samsung Galaxy A52', ['Samsung Galaxy A52 5G']],
    ['Samsung Galaxy A23', ['Samsung Galaxy A23 5G']],
    ['Samsung Galaxy A07', ['Samsung Galaxy A07 5G']],
    ['Samsung Galaxy A06', ['Samsung Galaxy A06 5G']],
    ['Xiaomi Redmi Note 14 4G', ['Xiaomi Redmi Note 14 Pro']],
    ['Xiaomi Redmi 15c', ['Xiaomi Redmi 14C']],
    ['Xiaomi Redmi A3', ['Xiaomi Redmi A5']],
    ['Oppo A5 Pro', ['Oppo A5']],
    ['Realme C75 4G', ['Realme C75x']]
  ]);

  const normalizeModelName = (model) => model
    .replace(/^Apple(?=\s+iPhone\b)/i, '')
    .replace(/^Samsung\s+Galaxy(?=\s)/i, 'Samsung')
    .replace(/\(\s*(4G|5G\+?)\s*\)/gi, ' $1')
    .replace(/\s{2,}/g, ' ')
    .trim();

  // Keep network variants separate: case dimensions can differ between 4G and 5G.
  // These aliases only apply to the built-in list; Theme Editor custom models stay intact.
  const defaultModelAliases = new Map([
    ['Samsung S25 FE', 'Samsung S25 FE 5G'],
    ['Samsung A73', 'Samsung A73 5G'],
    ['Samsung A54', 'Samsung A54 5G'],
    ['Samsung A53', 'Samsung A53 5G'],
    ['Samsung A52', 'Samsung A52 4G'],
    ['Samsung A51', 'Samsung A51 4G'],
    ['Samsung A23', 'Samsung A23 4G'],
    ['Samsung A16', 'Samsung A16 4G'],
    ['Samsung A17', 'Samsung A17 4G'],
    ['Samsung A07', 'Samsung A07 4G'],
    ['Samsung A06', 'Samsung A06 4G'],
    ['Samsung A04', 'Samsung A04 4G'],
    ['Samsung A03', 'Samsung A03 4G'],
    ['Samsung M52', 'Samsung M52 5G'],
    ['Xiaomi Redmi Note 13', 'Xiaomi Redmi Note 13 4G'],
    ['Xiaomi Redmi Note 12', 'Xiaomi Redmi Note 12 4G'],
    ['Xiaomi Redmi Note 10', 'Xiaomi Redmi Note 10 4G'],
    ['Xiaomi Redmi Note 11 Pro', 'Xiaomi Redmi Note 11 Pro 4G'],
    ['Xiaomi Redmi Note 10 Pro', 'Xiaomi Redmi Note 10 Pro 4G'],
    ['Oppo Reno 15', 'Oppo Reno 15 5G'],
    ['Oppo Reno 14 Pro', 'Oppo Reno 14 Pro 5G'],
    ['Oppo Reno 14', 'Oppo Reno 14 5G'],
    ['Oppo Reno 10', 'Oppo Reno 10 5G'],
    ['Oppo Reno 8', 'Oppo Reno 8 4G'],
    ['Oppo Reno 8T', 'Oppo Reno 8T 4G'],
    ['Oppo Reno 7', 'Oppo Reno 7 4G'],
    ['Oppo Reno 6', 'Oppo Reno 6 4G'],
    ['Oppo Reno 3', 'Oppo Reno 3 4G'],
    ['Oppo A78', 'Oppo A78 4G'],
    ['Realme 11', 'Realme 11 4G'],
    ['Realme 10', 'Realme 10 4G'],
    ['Realme 9', 'Realme 9 4G'],
    ['Realme 9i', 'Realme 9i 4G'],
    ['Realme 8', 'Realme 8 4G'],
    ['Realme 7', 'Realme 7 4G'],
    ['Realme Narzo 50', 'Realme Narzo 50 4G'],
    ['Honor 200 Lite', 'Honor 200 Lite 5G'],
    ['Honor 200', 'Honor 200 5G'],
    ['Infinix Note 12 Pro', 'Infinix Note 12 Pro 4G'],
    ['Infinix Note 12', 'Infinix Note 12 4G'],
    ['Infinix Note 50S', 'Infinix Note 50s 5G+'],
    ['Infinix Hot 60i', 'Infinix Hot 60i 4G'],
    ['Infinix Hot 30', 'Infinix Hot 30 4G'],
    ['Infinix Hot 20', 'Infinix Hot 20 4G'],
    ['Vivo Y100', 'Vivo Y100 4G']
  ]);
  const invalidDefaultModels = new Set([
    'iPhone 7G',
    'Samsung A54 4G',
    'Samsung A53 4G',
    'Samsung A34 4G'
  ]);

  class PhoneModelPicker extends HTMLElement {
    connectedCallback() {
      if (!this.ready) {
        this.trigger = this.querySelector('[data-phone-model-trigger]');
        this.valueNode = this.querySelector('[data-phone-model-value]');
        this.panel = this.querySelector('[data-phone-model-panel]');
        this.errorMessage = this.querySelector('[data-phone-model-error]');
        this.search = this.querySelector('[data-phone-model-search]');
        this.list = this.querySelector('[data-phone-model-list]');
        this.field = this.querySelector('[data-phone-model]');
        if (!this.trigger || !this.valueNode || !this.panel || !this.search || !this.list || !this.field) return;

        const customSource = this.querySelector('[data-phone-model-custom]');
        const customModels = customSource?.content?.textContent?.trim();
        const models = customModels
          ? customModels.split(/\r?\n/).map((model) => model.trim()).filter(Boolean)
          : defaultModels;
        const completeModels = [];
        for (const model of models) {
          const additions = modelAdditions.get(model);
          if (additions) completeModels.push(...additions);
          completeModels.push(model);
        }
        const seenModels = new Set();
        this.models = completeModels.map((model) => {
          const normalized = normalizeModelName(model);
          return customModels ? normalized : (defaultModelAliases.get(normalized) || normalized);
        }).filter((model) => {
          const key = model.toLowerCase();
          if (!model || (!customModels && invalidDefaultModels.has(model)) || seenModels.has(key)) return false;
          seenModels.add(key);
          return true;
        });
        this.searchableModels = this.models.map((model) => model.toLocaleLowerCase());
        this.placeholder = this.valueNode.textContent.trim();
        this.options = [];
        this.activeIndex = -1;
        this.batchSize = 48;
        this.renderedCount = 0;

        this.trigger.addEventListener('click', () => {
          if (this.panel.hidden) this.open();
          else this.close();
        });
        this.trigger.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            event.preventDefault();
            this.open();
            this.search.focus();
          }
        });
        this.search.addEventListener('input', () => {
          const typed = normalizeModelName(this.search.value.trim());
          this.field.value = typed;
          this.valueNode.textContent = typed || this.placeholder;
          if (typed) this.clearError();
          this.field.dispatchEvent(new Event('change', { bubbles: true }));
          this.render();
        });
        this.search.addEventListener('keydown', (event) => this.onKeydown(event));
        this.list.addEventListener('click', (event) => {
          const option = event.target.closest('[data-model-index]');
          if (option && this.list.contains(option)) {
            this.select(this.options[Number(option.dataset.modelIndex)]);
          }
        });
        this.list.addEventListener('scroll', () => {
          if (this.list.scrollTop + this.list.clientHeight >= this.list.scrollHeight - 80) {
            this.appendNextBatch();
          }
        }, { passive: true });
        this.onOutsidePointer = (event) => {
          if (!this.contains(event.target)) this.close();
        };
        this.onOutsideFocus = (event) => {
          if (!this.contains(event.target)) this.close();
        };
        this.ready = true;
      }

      document.addEventListener('pointerdown', this.onOutsidePointer, { passive: true });
      document.addEventListener('focusin', this.onOutsideFocus);
    }

    disconnectedCallback() {
      document.removeEventListener('pointerdown', this.onOutsidePointer);
      document.removeEventListener('focusin', this.onOutsideFocus);
    }

    showError(message) {
      if (!this.errorMessage || !this.trigger) return false;
      this.errorMessage.textContent = message;
      this.errorMessage.hidden = false;
      this.trigger.setAttribute('aria-invalid', 'true');
      this.trigger.setAttribute('aria-describedby', this.errorMessage.id);
      return true;
    }

    clearError() {
      if (!this.errorMessage || !this.trigger) return;
      this.errorMessage.hidden = true;
      this.errorMessage.textContent = '';
      this.trigger.removeAttribute('aria-invalid');
      this.trigger.removeAttribute('aria-describedby');
    }

    open() {
      this.search.value = '';
      this.panel.hidden = false;
      this.trigger.setAttribute('aria-expanded', 'true');
      this.render();
    }

    close() {
      this.panel.hidden = true;
      this.trigger.setAttribute('aria-expanded', 'false');
      this.search.removeAttribute('aria-activedescendant');
      this.activeIndex = -1;
    }

    render() {
      const typed = normalizeModelName(this.search.value.trim());
      const query = typed.toLocaleLowerCase();
      const matches = [];
      let exactMatch = false;
      if (query) {
        for (let index = 0; index < this.models.length; index += 1) {
          if (this.searchableModels[index].includes(query)) {
            matches.push(this.models[index]);
            if (this.searchableModels[index] === query) exactMatch = true;
          }
        }
      } else {
        matches.push(...this.models);
      }

      this.showCustomOption = Boolean(query && !exactMatch);
      this.options = this.showCustomOption ? [typed, ...matches] : matches;
      this.activeIndex = -1;
      this.search.removeAttribute('aria-activedescendant');
      this.list.replaceChildren();
      this.list.scrollTop = 0;
      this.renderedCount = 0;
      this.appendNextBatch();
    }

    appendNextBatch() {
      if (this.renderedCount >= this.options.length) return;
      const fragment = document.createDocumentFragment();
      const end = Math.min(this.renderedCount + this.batchSize, this.options.length);
      for (let index = this.renderedCount; index < end; index += 1) {
        const model = this.options[index];
        const option = document.createElement('button');
        option.type = 'button';
        option.className = 'phone-model-picker__option';
        option.id = `${this.search.id}-option-${index}`;
        option.dataset.modelIndex = String(index);
        option.setAttribute('role', 'option');
        option.setAttribute('aria-selected', 'false');
        option.textContent = index === 0 && this.showCustomOption
          ? `Use “${model}”`
          : model;
        fragment.append(option);
      }
      this.list.append(fragment);
      this.renderedCount = end;
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
        this.trigger.focus();
        return;
      }
      if (event.key === 'Tab') {
        this.close();
        return;
      }
      if (event.key === 'Enter') {
        event.preventDefault();
        const model = this.activeIndex >= 0
          ? this.options[this.activeIndex]
          : this.search.value.trim();
        if (model) this.select(model);
        return;
      }
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
      if (!this.options.length) return;
      event.preventDefault();
      const step = event.key === 'ArrowDown' ? 1 : -1;
      this.activeIndex = (this.activeIndex + step + this.options.length) % this.options.length;
      while (this.activeIndex >= this.renderedCount) this.appendNextBatch();
      this.list.querySelectorAll('[role="option"]').forEach((option, index) => {
        const active = index === this.activeIndex;
        option.setAttribute('aria-selected', String(active));
        option.classList.toggle('is-active', active);
        if (active) {
          this.search.setAttribute('aria-activedescendant', option.id);
          option.scrollIntoView({ block: 'nearest' });
        }
      });
    }

    select(model) {
      const normalizedModel = normalizeModelName(model);
      if (!normalizedModel) return;
      this.field.value = normalizedModel;
      this.valueNode.textContent = normalizedModel;
      this.clearError();
      this.field.dispatchEvent(new Event('change', { bubbles: true }));
      this.close();
      this.trigger.focus();
    }
  }

  customElements.define('phone-model-picker', PhoneModelPicker);
}